<template>
  <div class="evaluation-viewer-top-bar">
    <el-row>
      <el-col :span="12">
        <h3>{{ evaluation.layout.name }}</h3>
        <star-rating :score="evaluation.stars"/>
      </el-col>
      <el-col
        :span="12"
        class="text-right"
      >
        <el-dropdown
          trigger="click"
          @command="handleCommand"
        >
          <span class="el-dropdown-link">
            <i class="icon-more_vert"/>
          </span>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item command="print">
              <span @click.native="print">
                Imprimir
              </span>
            </el-dropdown-item>
            <el-dropdown-item command="exit">
              <span @click.native="exit">
                Salir
              </span>
            </el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import StarRating from '@/components/star-rating'

/**
   * 'EvaluationViewerTopBar' Component
   * @version 1.0.0
   * @author Fernando Torres
   * @copyright Marciano Studio S.C., 2018
   */
export default {
  name: 'EvaluationViewerTopBar',
  components: {
    StarRating
  },
  props: {
    evaluation: {
      type: Object,
      required: true
    }
  },
  methods: {
    handleCommand (c) {
      switch (c) {
        case 'print':
          this.print()
          break
        case 'exit':
          this.exit()
          break
      }
    },
    print () {
      window.print()
    },
    exit () {
      this.$router.go(-1)
    }
  }
}
</script>

////////////////////////////////////////////
//                                   STYLE
////////////////////////////////////////////
<style lang="scss" scoped>
  .evaluation-viewer-top-bar {
    box-shadow: 0 0 15px rgba(0, 0, 0, 0.2);
    padding: 20px;
    h3 {
      @include font-primary(18px, light);
      margin: 0;
    }
    h4 {
      @include font-primary(14px, regular);
      margin: 0;
    }
  }

  .icon-more_vert {
    font-size: 14px;
  }
</style>



// WEBPACK FOOTER //
// src/modules/evaluation-viewer/components/evaluation-viewer-top-bar.vue